import React from 'react';
import Layout from '../layout/Layout';
import Section from '../ui/Section';
import PageHero from '../ui/PageHero';
import terms from '../../content/terms.json';

const Terms = () => (
  <Layout>
    <PageHero
      tint="cream"
      eyebrow="The fine print"
      title="Terms & Conditions."
      lead="Please make sure you’ve read through the terms below. Shopstar is a product developed and owned by Shopstar PTY LTD (Reg Nr 2014/192666/07)."
    />
    <Section tone="white" pad="lg">
      <article
        className="ss-prose max-w-[820px] [&_h2]:border-t [&_h2]:border-line [&_h2]:pt-6 [&_h2:first-child]:border-t-0 [&_h2:first-child]:pt-0"
        /* First-party static legal content. */
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{ __html: terms.bodyHtml }}
      />
    </Section>
  </Layout>
);

export default Terms;
